<nav class="navbar navbar-expand-lg navbar-light bg-light" [class.active]="classApplied" ngStickyNav stickyClass="sticky-box-shadow">
  <div class="contenedor-navbar">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <a class="navbar-brand" href="https://www.collective-energy.lat">
          <img src="/assets/logo-latam-blanco.png" width="200" alt="Logo">
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleClass()">
          <span class="burger-menu">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
          </span>
        </button>
      </div>
   
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto mr-2 align-items-center" >
        <li class="nav-item" [class.active]="currentSection === 'about-us'">
          <div >
            <a href="https://www.collective-energy.lat/about-us" class="link-btn texto-blanco texto-secciones punto" (click)="closeMenu()">
              SOBRE NOSOTROS</a>
          </div>
        </li>
       
        <li class="nav-item" [class.active]="currentSection === 'productos'">
          <div>
            <a href="https://www.collective-energy.lat/byd-betterybox" class="link-btn texto-blanco texto-secciones" (click)="closeMenu()">
              PRODUCTOS</a>
          </div>
        </li>

        <li class="nav-item" [class.active]="currentSection === 'soluciones'">
          <div>
            <a href="https://www.collective-energy.lat/solutions" class="link-btn texto-blanco texto-secciones" (click)="closeMenu()">
              SOLUCIONES C&I</a>
          </div>
        </li>
        <li class="nav-item" [class.active]="currentSection === 'servicio'">
          <div>
            <a href="https://www.collective-energy.lat/service" class="link-btn texto-blanco texto-secciones" (click)="closeMenu()">
              SERVICIO</a>
          </div>
        </li>
        <li class="nav-item" [class.active]="currentSection === 'carga-ve'">
          <div>
            <a href="https://www.collective-energy.lat/charging" class="link-btn texto-blanco texto-secciones" (click)="closeMenu()">
              CARGA VE</a>
          </div>
        </li>
        <li class="nav-item" [class.active]="currentSection === 'contacto'">
          <div>
            <a href="https://www.collective-energy.lat/Where-to-buy" class="link-btn texto-blanco texto-secciones" (click)="closeMenu()">
              CONTACTO</a>
          </div>
        </li>
        <!-- <li class="nav-item" [class.active]="currentSection === 'Contact'">
          <div>
            <a [routerLink]="['/Contact']" [queryParams]="{ section: 'Contact' }" class="link-btn texto-blanco texto-secciones" (click)="changeSection('section5'); closeMenu()"></a>
          </div>
        </li> -->
      </ul>
      <ul class="navbar-nav ml-auto d-flex align-items-center">
        <li class="nav-item" [class.active]="currentSection === 'Online-service-center'">

            <a href="https://support.collective-energy.africa/" target="_blank" class="link-btn texto-secciones " (click)="changeSection('section6'); closeMenu()" style="margin-right: 0em;color:#3A9B43">
              CENTRO DE SERVICIO ONLINE
            </a>

        </li>
        <li class="nav-item text-right">
          <div>
            <button class="btn btn-primary" style="margin-top: 2.5em; margin-right: 1.5em;">
              <a href="https://docs.collective-energy.lat/"  (click)="closeMenu()">
                <span class="texto-blanco texto-secciones" style="border-bottom: transparent !important;">DESCARGAS</span>
              </a>
            </button>
          </div>
        </li>
      </ul>
      <ul class="navbar-nav ml-left for-responsive">
        <li class="nav-item"><a class="nav-link" href="https://www.collective-energy.lat/about-us" (click)="closeMenu()">SOBRE NOSOTROS</a></li>
        <li class="nav-item"><a class="nav-link" href="https://www.collective-energy.lat/byd-betterybox" (click)="closeMenu()">PRODUCTOS</a></li>
        <li class="nav-item"><a class="nav-link" href="https://www.collective-energy.lat/solutions" (click)="closeMenu()">SOLUCIONES C&I</a></li>
        <li class="nav-item"><a class="nav-link" href="https://www.collective-energy.lat/service" (click)="closeMenu()">SERVICIO</a></li>
        <li class="nav-item"><a class="nav-link" href="https://www.collective-energy.lat/charging" (click)="closeMenu()">CARGA VE</a></li>
        <li class="nav-item"><a class="nav-link" href="https://www.collective-energy.lat/Where-to-buy" (click)="closeMenu()">CONTACTO</a></li>
        <li class="nav-item">
          <a class="nav-link" href="https://docs.collective-energy.lat/" (click)="closeMenu()">Online service center</a>
        </li>                
        <li class="nav-item"><span class="nav-link" style="color: #3A9B43;" href="http://docs.collective-energy.africa/" (click)="closeMenu()">DOWNLOADS</span></li>
      </ul>
      </div>
    </div>
  </div>
</nav>
